/* Language suggestion bar. See snippets/misaj-lang-suggest.liquid for why detection is
   by browser language rather than by IP.

   The bar is rendered hidden and only revealed when the visitor's own first language
   preference is a language this store publishes and is not the one already being shown.
   Anything else — a match on the current language, no match at all, a previous dismissal
   — leaves it hidden, which is the common case. */
(function () {
  var bar = document.querySelector('[data-lang-suggest]');
  if (!bar) return;

  var STORE_KEY = 'misaj:lang-suggest-dismissed';
  try {
    if (localStorage.getItem(STORE_KEY) === '1') return;
  } catch (e) {
    /* Private mode or storage disabled: fall through and show it. Better to offer the
       language again than to never offer it at all. */
  }

  function base(tag) {
    return String(tag || '').toLowerCase().split('-')[0];
  }

  var current = base(bar.getAttribute('data-current'));
  var options = {};
  bar.querySelectorAll('[data-lang-option]').forEach(function (btn) {
    options[base(btn.getAttribute('data-lang-option'))] = btn;
  });

  /* Ordered by the visitor's own preference, so the first hit wins. Stopping at the
     first recognised language — rather than scanning for any match — is what keeps the
     bar quiet for someone whose top choice is already the language on screen. */
  var prefs = navigator.languages && navigator.languages.length
    ? navigator.languages
    : [navigator.language];

  var target = null;
  for (var i = 0; i < prefs.length; i++) {
    var want = base(prefs[i]);
    if (want === current) break;
    if (options[want]) {
      target = options[want];
      break;
    }
  }
  if (!target) return;

  /* Switch outright instead of asking. No redirect loop is possible: the switch lands on
     the matched language, which then equals `current`, so the loop above breaks before
     it ever finds a target again. The flag is belt-and-braces for a visitor who has
     since switched back by hand — without it, their choice would be undone on the next
     page load. */
  if (bar.getAttribute('data-mode') === 'auto') {
    var AUTO_KEY = 'misaj:lang-auto-done';
    var done;
    try {
      done = localStorage.getItem(AUTO_KEY) === '1';
    } catch (e) {}
    if (done) return;
    try {
      localStorage.setItem(AUTO_KEY, '1');
    } catch (e) {}
    target.click();
    return;
  }

  target.hidden = false;
  bar.hidden = false;

  var dismiss = bar.querySelector('[data-lang-dismiss]');
  if (dismiss) {
    dismiss.addEventListener('click', function () {
      bar.hidden = true;
      try {
        localStorage.setItem(STORE_KEY, '1');
      } catch (e) {}
    });
  }
})();
